var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"scoreCanvas"}},[_c('div',{staticClass:"scoreNum"},[_c('ScoreComponent'),_c('p',{staticClass:"scoreTitle"},[_vm._v("您是一个诚信的师傅，继续努力")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }